<template>
  <div class="app-container">
    <div class="page-top">
      <div class="p-left">
        <span class="bread-father" @click="toSceneHome">产品选型</span> /
        场景选型
      </div>
      <el-select
        v-model="selSceneId"
        placeholder="更多"
        style="width: 110px"
        size="small"
        @change="handleSceneChange"
      >
        <el-option
          v-for="item in sceneList"
          :key="item.sceneId"
          :label="item.sceneName"
          :value="item.sceneId"
        />
      </el-select>
    </div>
    <div class="dragger-try" @wheel="handleWheelRock" ref="draggerRef">
      <div class="dg-tip">按住鼠标左键可拖动图片</div>
      <div
        class="dg-area"
        ref="draggerAreaRef"
        :style="`cursor: ${
          isDragger ? 'grabbing' : 'grab'
        };transform: translate(calc(-50% + ${
          lastMoveX + moveX
        }px), calc(-50% + ${lastMoveY + moveY}px)) scale(${scale})`"
      >
        <img
          class="d-img"
          :src="presentScene.mainImg"
          alt=""
          :width="draggerAreaWidth"
          :height="draggerAreaHeight"
        />
        <!-- :style="`transform: scale(${scale})`" -->
      </div>
      <div
        class="dg-dots"
        @mousedown="handleImageDown"
        @mouseup="handleImageUp"
        @mousemove="handleImageMove"
        :style="`width: ${draggerAreaWidth * scale}px;height: ${
          draggerAreaHeight * scale
        }px;cursor: ${
          isDragger ? 'grabbing' : 'grab'
        };transform: translate(calc(-50% + ${
          lastMoveX + moveX
        }px), calc(-50% + ${lastMoveY + moveY}px))`"
      >
        <span
          class="dot"
          :class="{ 'dot-on': dot.positionId == selPositionId }"
          v-for="(dot, i) in sceneDotList"
          :key="i"
          :style="`left: ${
            toFormatDotsPosition(dot.xposition || 0) - positionOffsetX
          }px;top: ${
            toFormatDotsPosition(dot.yposition || 0) - positionOffsetY
          }px;`"
          @mousedown="handleDotDown"
          @mouseup="handleDotUp"
          @mousemove="handleDotMove"
          @click="(e) => handleDotClick(e, dot)"
        ></span>
      </div>
      <div class="dg-action" v-if="presentScene.sceneId">
        <span class="action" @click="toFullScreen"
          ><img src="@/assets/img/scene-whole.png" alt="" />{{
            isFullScreen ? '点击退出全屏' : '自适应'
          }}</span
        >
        <span class="action" @click="toImageLarge"
          ><img src="@/assets/img/scene-large.png" alt="" />放大</span
        >
        <span class="action" @click="toImageSmall"
          ><img src="@/assets/img/scene-small.png" alt="" />缩小</span
        >
      </div>
      <div
        class="dg-shadow"
        v-if="detailVisible"
        :style="`${detailPosition}: 10px`"
      >
        <!-- @wheel="(e) => e.stopPropagation()" -->
        <div class="dg-detail">
          <div class="d-left">
            <div
              class="l-img"
              @mouseenter="handleBlowMouseEnter"
              @mouseleave="handleBlowMouseLeave"
              @mousemove="handleBlowMouseMove"
            >
              <img :src="selPosition.commodityImg" alt="" />
              <div
                class="l-blow-shadow"
                v-if="isBlow"
                :style="`width: ${blowBoxWidth}px;height: ${blowBoxHeight}px;top: ${blowBoxTop}px;left: ${blowBoxLeft}px`"
              ></div>
            </div>
            <div class="l-blow" v-if="isBlow">
              <img
                :src="selPosition.commodityImg"
                alt=""
                :width="blowRatio * 100 + '%'"
                :height="blowRatio * 100 + '%'"
                :style="`left: ${blowLeft}px;top: ${blowTop}px;`"
              />
            </div>
            <p
              class="l-tip"
              :title="selPosition.commodityRecommendationReasons"
            >
              {{ selPosition.commodityRecommendationReasons }}
            </p>
          </div>
          <div class="d-right">
            <p class="r-title">{{ selPosition.positionName }}</p>
            <div class="r-list">
              <span class="l-title">品牌：</span>
              <div class="l-all">
                <span
                  class="a-brand"
                  :class="detailBrandSel == brand.key && 'a-brand-on'"
                  v-for="brand in detailBrand"
                  :key="brand.key"
                  @click="toChoiceBrand(brand)"
                  >{{ brand.value }}</span
                >
              </div>
            </div>
            <template v-if="Boolean(detailBrandSel)">
              <p class="r-line"></p>
              <div class="r-list">
                <span class="l-title">系列：</span>
                <div class="l-all">
                  <span
                    class="a-brand"
                    :class="detailSeriesSel == series.key && 'a-brand-on'"
                    v-for="series in detailSeries"
                    :key="series.key"
                    @click="toChoiceSeries(series)"
                    >{{ series.value }}</span
                  >
                </div>
              </div>
            </template>
          </div>
          <div class="d-close" @click="toCloseDetail">
            <img src="@/assets/img/scene-close.png" alt="" />
          </div>
          <div class="d-ask">请选择下方商品去询价</div>
        </div>
      </div>
    </div>
    <div class="goods">
      <template v-if="goodsList.length > 0">
        <Goods
          class="d-one"
          v-for="(item, i) in goodsList"
          :key="i"
          :item="item"
        />
      </template>
      <el-empty
        style="width: 100%"
        :image-size="140"
        v-else
        description="专家推荐中，敬请期待"
      />
    </div>
  </div>
</template>

<script>
import { setFullScreen, outFullScreen, listenOutFullScreem } from './fullScreen'
import Goods from './components/Goods'
import Tooltip from '@/components/tooltipShow/index'

export default {
  name: '',
  components: {
    Goods,
    Tooltip
  },
  data () {
    return {
      goodsList: [],
      scene: {},
      sceneList: [],
      selSceneId: null,
      sceneDotList: [],
      selPositionId: null,
      selPosition: {},
      detailPosition: 'left', // 商品详情位置
      detailVisible: false,
      detailBrand: [],
      detailSeries: [],
      detailBrandSel: null,
      detailSeriesSel: null,
      /** 图片拖拽放大相关 */
      draggerContainerWidth: null, // 抓取容器宽高
      draggerContainerHeight: null,
      draggerImageWidth: null, // 图片真实宽高
      draggerImageHeight: null,
      isDragger: false,
      scale: 1,
      maxScale: 3, // 最大放大倍数
      minScale: 0.5, // 最小缩小倍数
      startX: 0,
      startY: 0,
      moveX: 0,
      moveY: 0,
      lastMoveX: 0,
      lastMoveY: 0,
      isFullScreen: false,
      positionOffsetX: 11, // 点位偏移值,与点位图片大小有关
      positionOffsetY: 32,
      /** 图片局部放大相关 */
      isBlow: false,
      blowBoxWidth: 52, // 抓取框宽高
      blowBoxHeight: 52,
      blowBoxMoveMinTop: 0, // 抓取框移动最小上边距和左边距
      blowBoxMoveMinLeft: 0,
      blowBoxLeft: 0,
      blowBoxTop: 0,
      originViewWidth: 0, // 源视图宽高
      originViewHeight: 0
    }
  },
  computed: {
    // 图片初始左边距
    draggerAreaOriginLeft () {
      return (this.draggerContainerWidth - this.draggerAreaWidth) / 2
    },
    // 抓取区域的宽高比
    draggerContainerRatio () {
      return this.draggerContainerWidth / this.draggerContainerHeight
    },
    // 抓取区域宽高,也就是图片显示宽高
    draggerAreaWidth () {
      let imgRatio = this.draggerImageWidth / this.draggerImageHeight
      switch (true) {
        case this.draggerImageWidth < this.draggerContainerWidth &&
          this.draggerImageHeight < this.draggerContainerHeight:
          return this.draggerImageWidth
        case imgRatio > this.draggerContainerRatio:
          return this.draggerContainerWidth
        default:
          return imgRatio * this.draggerContainerHeight
      }
    },
    draggerAreaHeight () {
      let imgRatio = this.draggerImageWidth / this.draggerImageHeight
      switch (true) {
        case this.draggerImageWidth < this.draggerContainerWidth &&
          this.draggerImageHeight < this.draggerContainerHeight:
          return this.draggerImageHeight
        case imgRatio > this.draggerContainerRatio:
          return this.draggerContainerWidth / imgRatio
        default:
          return this.draggerContainerHeight
      }
    },
    draggerAreaZoomRatio () {
      return this.draggerImageWidth
        ? this.draggerAreaWidth / this.draggerImageWidth
        : 0
    },
    // 抓取框移动最大上边距和左边距
    blowMoveMaxTop () {
      return this.originViewHeight - this.blowBoxHeight
    },
    blowMoveMaxLeft () {
      return this.originViewWidth - this.blowBoxWidth
    },
    // 放大倍率
    blowRatio () {
      return this.originViewWidth / this.blowBoxWidth
    },
    // 缩放图上边距和左边距
    blowLeft () {
      return -(this.blowBoxLeft * this.blowRatio)
    },
    blowTop () {
      return -(this.blowBoxTop * this.blowRatio)
    },
    presentScene () {
      let scene = this.sceneList.find((v) => v.sceneId === this.selSceneId)
      return scene || {}
    }
  },
  async mounted () {
    this.selSceneId = this.$route.query.sceneId
    await this.getScene()
    // 获取基础数据
    this.draggerContainerWidth = this.$refs.draggerRef.clientWidth
    this.draggerContainerHeight = this.$refs.draggerRef.clientHeight
  },
  methods: {
    getDraggerImageInfo () {
      return new Promise((resolve) => {
        let img = new Image()
        img.src = this.presentScene.mainImg
        img.onload = () => {
          this.draggerImageWidth = img.width
          this.draggerImageHeight = img.height
          resolve(true)
        }
      })
    },
    async handleSceneChange () {
      // 重置画布状态
      this.scale = 1
      this.lastMoveY = 0
      this.lastMoveX = 0
      // 重置详情弹窗状态
      this.toCloseDetail()
      // 重新获取图片真实宽高
      await this.getDraggerImageInfo()
      // 获取下方商品
      this.getSku()
      // 获取点位
      this.getSceneDots()
    },
    getSceneDots () {
      this.$http
        .post(`/front/cross/commodity-user/position/queryPage`, {
          limit: 100000,
          page: 1,
          sceneId: this.selSceneId
        })
        .then(({ data: res }) => {
          this.sceneDotList = res.data.dataList
        })
    },
    getScene () {
      return this.$http
        .post(`/front/cross/commodity-user/queryPage`, {
          limit: 100000,
          page: 1,
          statusList: ['1']
        })
        .then(async ({ data: res }) => {
          this.sceneList = res.data.dataList
          if (this.presentScene.sceneId) {
            // 获取图片真实宽高
            await this.getDraggerImageInfo()
            this.getSku()
            this.getSceneDots()
          }
        })
    },
    getSku () {
      this.$http
        .post(`/front/cross/commodity-user/getSpuList`, {
          sceneId: this.selSceneId,
          positionId: this.selPositionId,
          brandId: this.detailBrandSel,
          seriesId: this.detailSeriesSel
        })
        .then(({ data: res }) => {
          this.goodsList = res.data
        })
    },
    toFullScreen () {
      // 展示详情的时候不能全屏
      if (this.detailVisible) return
      // const dom = aiStoreScreenRef.value;
      if (!this.isFullScreen) {
        this.isFullScreen = true
        setFullScreen(this.$refs.draggerRef)

        listenOutFullScreem().then(() => {
          this.isFullScreen = false
          outFullScreen()
        })
      } else {
        this.isFullScreen = false
        outFullScreen()
      }
    },
    toSceneHome () {
      this.$router.push('/sceneSelectionHome')
    },
    toImageLarge () {
      // 展示详情的时候不能放大缩小
      if (this.detailVisible) return
      this.scale += 0.1
    },
    toImageSmall () {
      // 展示详情的时候不能放大缩小
      if (this.detailVisible) return
      this.scale -= 0.1
    },
    handleImageDown (e) {
      this.isDragger = true
      this.startX = e.clientX
      this.startY = e.clientY
    },
    handleImageUp () {
      this.isDragger = false
      this.lastMoveX += this.moveX
      this.lastMoveY += this.moveY
      this.moveX = 0
      this.moveY = 0
    },
    handleImageMove (e) {
      e.preventDefault()
      //   console.log(e)
      if (this.isDragger) {
        this.moveX = e.clientX - this.startX
        this.moveY = e.clientY - this.startY
      }
    },
    handleWheelRock (e) {
      if (!this.presentScene.sceneId) return
      if (this.detailVisible) return
      e.preventDefault()

      let scale = this.scale + e.wheelDelta / 1200
      if (scale >= this.minScale && scale <= this.maxScale) this.scale = scale
    },
    handleBlowMouseMove (e) {
      let blowBoxLeft = e.offsetX - this.blowBoxWidth / 2
      let blowBoxTop = e.offsetY - this.blowBoxHeight / 2
      if (blowBoxLeft < this.blowBoxMoveMinLeft) {
        this.blowBoxLeft = this.blowBoxMoveMinLeft
      } else if (blowBoxLeft > this.blowMoveMaxLeft) {
        this.blowBoxLeft = this.blowMoveMaxLeft
      } else this.blowBoxLeft = blowBoxLeft
      if (blowBoxTop < this.blowBoxMoveMinTop) {
        this.blowBoxTop = this.blowBoxMoveMinTop
      } else if (blowBoxTop > this.blowMoveMaxTop) {
        this.blowBoxTop = this.blowMoveMaxTop
      } else this.blowBoxTop = blowBoxTop
    },
    handleBlowMouseEnter (e) {
      this.isBlow = true
      this.originViewWidth = e.target.clientWidth
      this.originViewHeight = e.target.clientHeight
    },
    handleBlowMouseLeave (e) {
      this.isBlow = false
    },
    handleDotDown (e) {
      e.stopPropagation()
    },
    handleDotUp (e) {
      e.stopPropagation()
    },
    handleDotMove (e) {
      e.stopPropagation()
    },
    handleDotClick (e, dot) {
      if (this.isFullScreen) this.toFullScreen()
      this.selPositionId = dot.positionId
      this.detailBrandSel = null
      this.detailSeriesSel = null
      this.detailSeries = []

      this.selPosition = { ...dot }
      let selPositionX =
        e.offsetX - this.positionOffsetX + dot.xposition + this.lastMoveX
      selPositionX += this.draggerAreaOriginLeft
      // 详情弹窗
      this.detailPosition =
        selPositionX * this.draggerAreaZoomRatio >
        this.draggerContainerWidth / 2
          ? 'left'
          : 'right'
      this.detailVisible = true
      // 获取点位品牌系列
      this.getBrandSeries()
      // 获取下方商品
      this.getSku()
    },
    getBrandSeries () {
      this.$http
        .get(
          `/front/cross/commodity-user/getBrandListByPositionId/${this.selPositionId}`
        )
        .then(({ data: res }) => {
          this.detailBrand = res.data
        })
    },
    toCloseDetail () {
      this.detailVisible = false
      // 重置弹窗选项
      this.detailBrandSel = null
      this.detailSeriesSel = null
      this.detailSeries = []
      this.selPositionId = null
    },
    toChoiceBrand (brand) {
      this.detailBrandSel = brand.key
      this.detailSeriesSel = null
      this.detailSeries = brand.extra
      // 获取下方商品
      this.getSku()
    },
    toChoiceSeries (series) {
      this.detailSeriesSel = series.key
      // 获取下方商品
      this.getSku()
    },
    toFormatDotsPosition (position) {
      return this.draggerAreaZoomRatio * position * this.scale
    }
  }
}
</script>
<style lang="scss" scoped>
.app-container {
  max-width: 1200px;
  width: 1200px;
  margin: 0 auto;
  .page-top {
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .p-left {
      font-size: 16px;
      font-weight: 500;
      line-height: 54px;
      .bread-father {
        color: #999999;
        cursor: pointer;
      }
    }
  }
  .dragger-try {
    width: 1200px;
    height: 675px;
    background-color: #fff;
    overflow: hidden;
    position: relative;
    border-radius: 12px;
    margin-bottom: 16px;
    .dg-tip {
      position: absolute;
      left: 12px;
      top: 12px;
      font-size: 14px;
      color: #666666;
      z-index: 1;
    }
    .dg-area {
      transform-origin: center center;
      position: absolute;
      left: 50%;
      top: 50%;
      .d-img {
        display: block;
        user-select: none;
        object-fit: contain;
        //   transform: translate(-50%, -50%);
        //   width: 100%;
        //   cursor: grab; // grabbing
      }
      .d-dots {
      }
    }
    .dg-dots {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 100%;
      height: 100%;
      .dot {
        position: absolute;
        width: 22px;
        height: 36px;
        background-image: url("../../../assets/img/scene-dot-default.png");
        background-position: -1px -3px;
        background-repeat: no-repeat;
        cursor: pointer;
        &:hover {
          background-image: url("../../../assets/img/scene-dot-hover.png");
        }
        &:active {
          background-image: url("../../../assets/img/scene-dot-click.png");
        }
        &.dot-on {
          background-image: url("../../../assets/img/scene-dot-on.png");
          background-position: 0 0;
        }
      }
    }
    .dg-action {
      position: absolute;
      right: 16px;
      bottom: 12px;
      display: flex;
      align-items: center;
      .action {
        font-size: 16px;
        margin-left: 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          margin-right: 9px;
        }
      }
    }
    .dg-shadow {
      // width: 100%;
      // height: 100%;
      background-color: transparent;
      position: absolute;
      // left: 0;
      // top: 0;
      bottom: 10px;
      z-index: 7;
    }
    .dg-detail {
      // position: absolute;
      position: relative;
      // bottom: 10px;
      width: 550px;
      height: 326px;
      border-radius: 9.6px;
      opacity: 1;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
      padding: 10px;
      display: flex;
      z-index: 8;
      .d-left {
        width: 260px;
        margin-right: 16px;
        flex-shrink: 0;
        position: relative;
        .l-img {
          width: 100%;
          height: 260px;
          background-color: #f6f5fa;
          border-radius: 6.22px;
          overflow: hidden;
          border: 0.52px solid #e1e3e6;
          position: relative;
          box-sizing: border-box;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            cursor: all-scroll;
          }
          .l-blow-shadow {
            width: 52px;
            height: 52px;
            background: rgba(42, 84, 209, 0.3);
            box-sizing: border-box;
            border: 1px dashed #2a54d1;
            position: absolute;
            // top: 0;
            // left: 0;
            user-select: none;
            pointer-events: none;
          }
        }
        .l-blow {
          width: 260px;
          height: 260px;
          background-color: #f6f5fa;
          border-radius: 6.22px;
          overflow: hidden;
          position: absolute;
          left: 270px;
          top: 0;
          z-index: 2;
          img {
            object-fit: contain;
            position: absolute;
          }
        }
        .l-tip {
          font-size: 14px;
          color: #646566;
          margin-top: 8px;
          margin-bottom: 0;
          height: 42px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          overflow: hidden;
          //   :deep(.career) {
          //     display: -webkit-box;
          //     -webkit-box-orient: vertical;
          //     -webkit-line-clamp: 2;
          //     text-overflow: ellipsis;
          //     overflow: hidden;
          //     white-space: inherit;
          //   }
        }
      }
      .d-right {
        padding-top: 12px;
        flex-grow: 1;
        .r-title {
          font-size: 16px;
          font-weight: bold;
          line-height: 22px;
          margin-bottom: 16px;
          margin-top: 0;
        }
        .r-list {
          display: flex;
          width: 100%;
          .l-title {
            font-size: 12px;
            text-decoration: underline;
            white-space: nowrap;
            margin-right: 8px;
            margin-bottom: 12px;
          }
          .l-all {
            display: flex;
            flex-wrap: wrap;
            .a-brand {
              font-size: 12px;
              color: #1a1a1a;
              white-space: nowrap;
              margin-right: 16px;
              line-height: 16px;
              margin-bottom: 12px;
              cursor: pointer;
              &.a-brand-on {
                color: #2a54d1;
                font-weight: bold;
              }
            }
          }
        }
        .r-line {
          height: 1px;
          background-color: #e1e3e5;
          margin: 0;
          margin-bottom: 12px;
        }
      }
      .d-close {
        position: absolute;
        right: 12px;
        top: 12px;
        cursor: pointer;
      }
      .d-ask {
        font-size: 12px;
        color: #2a54d1;
        position: absolute;
        right: 10px;
        bottom: 10px;
        // cursor: pointer;
      }
    }
  }
  .goods {
    --columns: 4;
    --gap: 16px;
    display: flex;
    flex-wrap: wrap;
    gap: var(--gap);
    .d-one {
      --goodsWidth: calc(
        (100% - (var(--columns) - 1) * var(--gap)) / var(--columns)
      );
      width: var(--goodsWidth);
    }
  }
}
</style>
